import { faCircleEllipsis } from "@fortawesome/pro-light-svg-icons/faCircleEllipsis";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { MprcChip } from "components";
import { ManagedEnrollmentClassroomListResponse } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useEnrollmentManagementContext } from "views/lms/enrollment/Home/EnrollmentManagementWrapper";
import { EnrollmentClassroomDialog } from "views/lms/enrollment/Home/Operation/EnrollmentClassroomDialog";

interface IProps {
    value?: ManagedEnrollmentClassroomListResponse;
    onChange: (item?: ManagedEnrollmentClassroomListResponse) => void;
    label?: string;
}

/**
 * Componente para seleção de turmas.
 * @param props
 */

export const EnrollmentSelectClassroom: React.FC<IProps> = (props) => {

    const { value, label, onChange } = props;

    const { t } = useTranslation("lms");
    const ctx = useEnrollmentManagementContext();
    const training = ctx.training!;

    const [dialog, setDialog] = useState<any>();

    ///
    const handleSelectClassroom = () => {
        setDialog(<EnrollmentClassroomDialog
            trainingId={training.trainingId}
            subtitle={training.name}
            onClose={(classroom) => {
                if (classroom) onChange(classroom);
                setDialog(null)}
            }
        />);
    };

    return (
        <>
            { dialog }

            <TextField
                label={label ?? t("Enrollment.StepOperation.ClassroomLabel")}
                placeholder={value == undefined ? t("Enrollment.StepOperation.ClassroomPlaceholder") : undefined}
                fullWidth
                disabled
                required
                slotProps={{
                    input: {
                        readOnly: true,
                        startAdornment:
                            <>
                                {
                                    value &&
                                        <InputAdornment position="start">
                                            <MprcChip
                                                label={value.name}
                                                size="small"
                                                onDelete={() => onChange(undefined)}
                                            />
                                        </InputAdornment>
                                }
                            </>,
                        endAdornment:
                            <InputAdornment position="end">
                                <IconButton onClick={() => handleSelectClassroom()} >
                                    <FontAwesomeIcon icon={faCircleEllipsis} size="sm" />
                                </IconButton>
                            </InputAdornment>
                    }
                }}
            />
        </>
    );
};
